import React, { ReactNode } from "react"
import { OrderShippingKlarnaShippingAssistant } from "lib/types/generated/graphql-types"
import { ReactComponent as KlarnaLogo } from "images/providers/klarna-logo.svg"
import CopyButton from "components/Ui/CopyButton"
import { getCountryName } from "helpers/countries"
import { ChildrenWrapper, Container, Row, Title } from "./Styled"

type Props = {
  shippingKlarna: OrderShippingKlarnaShippingAssistant | undefined
}

const KlarnaShippingAssistantDetails = ({ shippingKlarna }: Props) => {
  const getItem = (title: string, children: ReactNode) => {
    return (
      <div>
        <>
          <div>{title}</div>
          <div>{children}</div>
        </>
      </div>
    )
  }

  return (
    <>
      <Title $logoMargin={"0 0.8rem 0.3rem 0"}>
        <KlarnaLogo /> details
      </Title>
      <Container>
        <Row>
          {getItem(
            "Reference",
            <b>
              {shippingKlarna?.reference} <CopyButton string={shippingKlarna?.reference} />
            </b>
          )}
          {getItem(
            "Klarna Merchant ID",
            <b>
              {shippingKlarna?.klarnaMerchantId}{" "}
              <CopyButton string={shippingKlarna?.klarnaMerchantId} />
            </b>
          )}
        </Row>
        <Row>
          {getItem(
            "Selected shipping",
            <ChildrenWrapper>
              <b> {shippingKlarna?.selectedShippingOption?.name} </b>
              <b> {shippingKlarna?.selectedShippingOption?.carrier} </b>
              <b>{shippingKlarna?.selectedShippingOption.carrierProduct?.name}</b>
            </ChildrenWrapper>
          )}
          {getItem(
            "Location",
            <ChildrenWrapper>
              <b>{shippingKlarna?.selectedShippingOption?.location?.name} </b>
              <b>{shippingKlarna?.selectedShippingOption?.location?.address?.streetAddress} </b>
              <b>{shippingKlarna?.selectedShippingOption?.location?.address?.streetAddress2} </b>
              <b>
                {shippingKlarna?.selectedShippingOption?.location?.address?.postalCode}{" "}
                {shippingKlarna?.selectedShippingOption?.location?.address?.city}
              </b>
              <b>{shippingKlarna?.selectedShippingOption?.location?.address?.region} </b>
              {shippingKlarna?.selectedShippingOption?.location?.address?.country && (
                <b>
                  {getCountryName(
                    shippingKlarna?.selectedShippingOption?.location?.address?.country
                  )}
                </b>
              )}
            </ChildrenWrapper>
          )}
        </Row>
      </Container>
    </>
  )
}

export default KlarnaShippingAssistantDetails
